
import { Component, HostBinding, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { UserService, UserTeam } from '@teammood/shared/util/user';
import { distinctUntilChanged, filter, from, map, mergeMap, Observable, Subject, takeUntil, tap } from "rxjs";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
    selector: 'tm-team-select',
    templateUrl: './team-select.component.html',
    styleUrls: ['./team-select.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
    ReactiveFormsModule,
    TranslateModule,
    MatSelectModule
]
})
export class TmTeamSelectComponent implements OnInit, OnDestroy {
  @HostBinding('class.tm-team-select') defaultClass = true;

  protected allowedteams: UserTeam[];

  protected selectedTeamCtrl = new FormControl<UserTeam>(null);

  @Input() permission: string;

  @Input() baseUrl: string;

  @Input() teamIdFromUrl: string;

  @Input() teams: Observable<UserTeam[]>;

  private _destroy$ = new Subject<void>();

  constructor(
    private userService: UserService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
  }

  ngOnInit() {

    this.selectedTeamCtrl.valueChanges.pipe(
        distinctUntilChanged(),
        filter(team => !!team),
        mergeMap(team => {

          return this.router.navigate([this.baseUrl, team.id], {queryParams: this.route.snapshot.queryParams}); // update URL in browser

        }),

        takeUntil(this._destroy$),
    ).subscribe();

    this.getTeams().pipe(
        tap(teams => {
          if(this.permission){
            this.allowedteams =  teams.filter(team => {
              return team.roles.indexOf(this.permission) !== -1;
            })
          }else{
            this.allowedteams = teams;
          }
          const teamId = this.getTeamId(teams)
          const selectedTeam = this.allowedteams.find((team) => team.id === teamId);
          this.selectedTeamCtrl.setValue(selectedTeam, { emitEvent: true });
        }),
        takeUntil(this._destroy$),
    ).subscribe();

  }

  private getTeams(): Observable<UserTeam[]> {
    if (this.teams) {
      return this.teams;
    } else {
      return from(this.userService.get()).pipe(
          map(user => user.teams)
      )
    }
  }

  ngOnDestroy() {
    this._destroy$.next();
    this._destroy$.complete();
  }

  private getTeamId(teams: UserTeam[]) {
    // set the team id from the Url
    const teamIdFromUrl: string = this.teamIdFromUrl;

    if (!teamIdFromUrl) {
      // if not in Url (/stats or /reporting), get it from the teams
      return teams[0].id;
    } else {
      return teamIdFromUrl;
    }
  }
}
